import { createSelector } from "@ngrx/store"
import { TipType, UserSettings } from 'globals/store/user.data';
import { settingsStateSelector } from "../settings.era";

const userSettings = createSelector(settingsStateSelector, (state) => state.user)

export const hideTipSelector = createSelector(
  userSettings,
  (settings: UserSettings, tipId: TipType) => {
    return settings?.hiddenTips?.includes(tipId)
  }
)